import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ee896c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = { class: "flex flex-1 justify-between sm:hidden" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "hidden sm:flex sm:flex-1 sm:items-center sm:justify-between" }
const _hoisted_6 = { class: "text-sm text-gray-700" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "font-medium" }
const _hoisted_10 = {
  class: "isolate inline-flex -space-x-px rounded-md shadow-xs",
  "aria-label": "Pagination"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "pagination-link"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))

import { ref, computed } from 'vue';

import ArrowIcon from '@/components/icons/ArrowIcon.vue';

import { PaginationI } from '@/interfaces/interfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'LogsPagination',
  props: {
    pagination: {}
  },
  emits: ["update:page"],
  setup(__props: any, { emit }) {

const props = __props;





const rangeFrom = computed(() => {
  if (!props.pagination.total) {
    return 0;
  }
  return (props.pagination.page - 1) * props.pagination.perPage + 1;
});

const rangeTo = computed(() => {
  return Math.min(props.pagination.page * props.pagination.perPage, props.pagination.total);
});

const pageNumbers = computed(() => {
  const lastPage = props.pagination.lastPage;
  const pages: (number | string)[] = Array.from({ length: lastPage }, (_, i) => i + 1);

  if (lastPage > 6) {
    const firstThree = pages.splice(0, 3);
    const lastThree = pages.splice(-3);
    return [...firstThree, '...', ...lastThree];
  }

  return pages;
});

const previousPage = () => {
  if (props.pagination.page > 1) {
    emit('update:page', props.pagination.page - 1);
  }
};

const nextPage = () => {
  if (props.pagination.page < props.pagination.lastPage) {
    emit('update:page', props.pagination.page + 1);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "#",
        class: "pagination-button-previus",
        onClick: _withModifiers(previousPage, ["prevent"])
      }, "Previous", 8, _hoisted_3),
      _createElementVNode("a", {
        href: "#",
        class: "pagination-button-next",
        onClick: _withModifiers(nextPage, ["prevent"])
      }, "Next", 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(" Showing "),
          _createElementVNode("span", _hoisted_7, _toDisplayString(rangeFrom.value), 1),
          _createTextVNode(" to "),
          _createElementVNode("span", _hoisted_8, _toDisplayString(rangeTo.value), 1),
          _createTextVNode(" of "),
          _createElementVNode("span", _hoisted_9, _toDisplayString(props.pagination.total), 1),
          _createTextVNode(" results ")
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("nav", _hoisted_10, [
          _createElementVNode("a", {
            href: "#",
            class: "pagination-button-previus",
            onClick: _withModifiers(previousPage, ["prevent"])
          }, [
            _hoisted_12,
            _createVNode(ArrowIcon, {
              class: "rotate-90 size-5",
              "aria-hidden": "true"
            })
          ], 8, _hoisted_11),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageNumbers.value, (page) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: page }, [
              (page !== '...')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: _normalizeClass(["pagination-link", { 'pagination-link-active': page === props.pagination.page }]),
                    onClick: _withModifiers(($event: any) => (emit('update:page', Number(page))), ["prevent"])
                  }, _toDisplayString(page), 11, _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, " ... "))
            ], 64))
          }), 128)),
          _createElementVNode("a", {
            href: "#",
            class: "pagination-button-next",
            onClick: _withModifiers(nextPage, ["prevent"])
          }, [
            _hoisted_16,
            _createVNode(ArrowIcon, {
              class: "-rotate-90 size-5",
              "aria-hidden": "true"
            })
          ], 8, _hoisted_15)
        ])
      ])
    ])
  ]))
}
}

})